'use client';

import { ReactNode } from "react";

let popstateHandler: (() => void) | null = null;
function closeMenu() {
  const hamburger = document.querySelector(`.hamburger`);
  const nav = document.querySelector(`.hamburger-menu`);
  if (hamburger) hamburger.classList.remove(`is-active`);
  if (nav) nav.classList.remove(`open`);
  document.body.style.overflow = ``;
  document.documentElement.style.overflow = ``;
  if (popstateHandler) {
    window.removeEventListener(`popstate`, popstateHandler);
    popstateHandler = null;
  }
}

export default function NavClient({ children, }: { children: ReactNode }) {
  const handleClick = (event: any) => {
    const isOpen = event.currentTarget.classList.toggle(`is-active`);
    const nav = document.querySelector(`.hamburger-menu`) as HTMLElement;
    if (nav) {
      nav.classList.toggle(`open`);
    }

    if (isOpen) {
      document.body.style.overflow = `hidden`;
      document.documentElement.style.overflow = `hidden`;
      history.pushState({ hamburger: true, }, ``);
      popstateHandler = () => {
        closeMenu();
      };
      window.addEventListener(`popstate`, popstateHandler, { once: true, });
    } else {
      document.body.style.overflow = ``;
      document.documentElement.style.overflow = ``;
      if (popstateHandler) {
        window.removeEventListener(`popstate`, popstateHandler);
        popstateHandler = null;
      }
      if (history.state?.hamburger) {
        history.back();
      }
    }
  };

  return (
    <>
      <div onClick={handleClick} className="hamburger">
        <span className="line"></span>
        <span className="line"></span>
        <span className="line"></span>
      </div>
      <div className="hamburger-menu">
        <div className="hamburger-menu-content">
          {children}
        </div>
      </div>
    </>
  );
}
